var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02033 15.0203C6.28839 15.2884 6.72018 15.2973 6.9991 15.0406L12 10.4372L17.0009 15.0406C17.2798 15.2973 17.7116 15.2884 17.9797 15.0203C18.2636 14.7364 18.2544 14.2732 17.9593 14.0009L12.6783 9.1261C12.2952 8.77251 11.7048 8.77251 11.3217 9.1261L6.04071 14.0009C5.74565 14.2732 5.73639 14.7364 6.02033 15.0203Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.1c02a53fe4053e919cbf81642d633305.svg";
export { ForwardRef as ReactComponent };